// Home page Collection list

$('.iamge-collection-slide').slick({
  speed: 300,
  arrows: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots:false,
  prevArrow: '<svg class="slick-prev slick-arrow" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" transform="rotate(-180 20 20)" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2879 26.7254C18.9218 27.0915 18.3282 27.0915 17.9621 26.7254L11.3996 20.1629C11.0335 19.7968 11.0335 19.2032 11.3996 18.8371L17.9621 12.2746C18.3282 11.9085 18.9218 11.9085 19.2879 12.2746C19.654 12.6407 19.654 13.2343 19.2879 13.6004L14.3258 18.5625L27.0625 18.5625C27.5803 18.5625 28 18.9822 28 19.5C28 20.0178 27.5803 20.4375 27.0625 20.4375L14.3258 20.4375L19.2879 25.3996C19.654 25.7657 19.654 26.3593 19.2879 26.7254Z" fill="black"/></svg>',
  nextArrow: '<svg class="slick-next slick-arrow" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group 3"><circle id="Ellipse 1" cx="19.9999" cy="20" r="20" fill="white"/><path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M20.712 13.2746C21.0781 12.9085 21.6717 12.9085 22.0378 13.2746L28.6003 19.8371C28.9664 20.2032 28.9664 20.7968 28.6003 21.1629L22.0378 27.7254C21.6717 28.0915 21.0781 28.0915 20.712 27.7254C20.3459 27.3593 20.3459 26.7657 20.712 26.3996L25.6741 21.4375H12.9374C12.4196 21.4375 11.9999 21.0178 11.9999 20.5C11.9999 19.9822 12.4196 19.5625 12.9374 19.5625H25.6741L20.712 14.6004C20.3459 14.2343 20.3459 13.6407 20.712 13.2746Z" fill="black"/></g></svg>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


// Home page Collection list end

// Home Product slider

$('.abz-product-slide-home').slick({
  speed: 300,
  arrows: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots:false,
  prevArrow: '<svg class="slick-prev slick-arrow" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" transform="rotate(-180 20 20)" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2879 26.7254C18.9218 27.0915 18.3282 27.0915 17.9621 26.7254L11.3996 20.1629C11.0335 19.7968 11.0335 19.2032 11.3996 18.8371L17.9621 12.2746C18.3282 11.9085 18.9218 11.9085 19.2879 12.2746C19.654 12.6407 19.654 13.2343 19.2879 13.6004L14.3258 18.5625L27.0625 18.5625C27.5803 18.5625 28 18.9822 28 19.5C28 20.0178 27.5803 20.4375 27.0625 20.4375L14.3258 20.4375L19.2879 25.3996C19.654 25.7657 19.654 26.3593 19.2879 26.7254Z" fill="black"/></svg>',
  nextArrow: '<svg class="slick-next slick-arrow" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Group 3"><circle id="Ellipse 1" cx="19.9999" cy="20" r="20" fill="white"/><path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M20.712 13.2746C21.0781 12.9085 21.6717 12.9085 22.0378 13.2746L28.6003 19.8371C28.9664 20.2032 28.9664 20.7968 28.6003 21.1629L22.0378 27.7254C21.6717 28.0915 21.0781 28.0915 20.712 27.7254C20.3459 27.3593 20.3459 26.7657 20.712 26.3996L25.6741 21.4375H12.9374C12.4196 21.4375 11.9999 21.0178 11.9999 20.5C11.9999 19.9822 12.4196 19.5625 12.9374 19.5625H25.6741L20.712 14.6004C20.3459 14.2343 20.3459 13.6407 20.712 13.2746Z" fill="black"/></g></svg>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

// Footer Accordian for Mobi & iPad
$(document).ready(function() {
  jQuery('.footer-block--menu h2.footer-block__heading').click(function() { 
      $(this).toggleClass("tab_active");
  });
});

// category slick slider

// $('.related-collection-links--buttons').slick({
//   arrows: false,
//   infinite: true,
//   slidesToShow: 10,
//   slidesToScroll: 1,
//   dots:false,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 5,
//         slidesToScroll: 1,
//         infinite: true
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });


 